document.addEventListener("DOMContentLoaded", function () {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (!isIOS) return;

  // Attente que le champ soit déplacé dans le DOM
  const searchInterval = setInterval(() => {
    const searchInput = document.querySelector('.mobile-nav--search input[type="search"], .mobile-nav--search input[type="text"]');
    
    if (searchInput) {
      clearInterval(searchInterval);

      // Patch pour iOS : forcer le focus sur clic ou touch
      searchInput.addEventListener("touchstart", () => {
        searchInput.focus();
      });

      // Optionnel : s'assurer qu'il est cliquable
      searchInput.style.pointerEvents = "auto";
      searchInput.style.zIndex = "9999";
    }
  }, 200);

  // Ne pas boucler indéfiniment
  setTimeout(() => clearInterval(searchInterval), 5000);
});

document.addEventListener("DOMContentLoaded", function () {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (!isIOS) return;

  const targetSelector = ".mobile-nav--search";
  const inputSelector = 'input[type="search"], input[type="text"]';

  const target = document.querySelector(targetSelector);
  if (!target) return;

  const applyFix = (input) => {
    input.addEventListener("touchstart", () => {
      input.focus();
    });

    input.style.pointerEvents = "auto";
    input.style.zIndex = "9999";
  };

  // Si l'input est déjà là
  const existingInput = target.querySelector(inputSelector);
  if (existingInput) {
    applyFix(existingInput);
    return;
  }

  // Sinon : observer le DOM
  const observer = new MutationObserver((mutations, obs) => {
    const input = target.querySelector(inputSelector);
    if (input) {
      applyFix(input);
      obs.disconnect();
    }
  });

  observer.observe(target, { childList: true, subtree: true });
});

